var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgressClaim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#FFF9EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89196 10.9871C6.46225 10.9871 6.92455 10.5247 6.92455 9.95446C6.92455 9.38418 6.46225 8.92188 5.89196 8.92188C5.32168 8.92188 4.85938 9.38418 4.85938 9.95446C4.85938 10.5247 5.32168 10.9871 5.89196 10.9871Z",
    fill: "#FFC825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0223 10.9871C10.5926 10.9871 11.0549 10.5247 11.0549 9.95446C11.0549 9.38418 10.5926 8.92188 10.0223 8.92188C9.45205 8.92188 8.98975 9.38418 8.98975 9.95446C8.98975 10.5247 9.45205 10.9871 10.0223 10.9871Z",
    fill: "#FFC825"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1527 10.9871C14.723 10.9871 15.1853 10.5247 15.1853 9.95446C15.1853 9.38418 14.723 8.92188 14.1527 8.92188C13.5824 8.92188 13.1201 9.38418 13.1201 9.95446C13.1201 10.5247 13.5824 10.9871 14.1527 10.9871Z",
    fill: "#FFC825"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09687 9.95469C7.09687 10.62 6.55752 11.1594 5.89219 11.1594C5.22686 11.1594 4.6875 10.62 4.6875 9.95469C4.6875 9.28936 5.22686 8.75 5.89219 8.75C6.55752 8.75 7.09687 9.28936 7.09687 9.95469ZM6.92478 9.95469C6.92478 10.525 6.46247 10.9873 5.89219 10.9873C5.3219 10.9873 4.8596 10.525 4.8596 9.95469C4.8596 9.3844 5.3219 8.9221 5.89219 8.9221C6.46247 8.9221 6.92478 9.3844 6.92478 9.95469Z",
    fill: "#FFC825"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2272 9.95469C11.2272 10.62 10.6879 11.1594 10.0226 11.1594C9.35723 11.1594 8.81787 10.62 8.81787 9.95469C8.81787 9.28936 9.35723 8.75 10.0226 8.75C10.6879 8.75 11.2272 9.28936 11.2272 9.95469ZM11.0551 9.95469C11.0551 10.525 10.5928 10.9873 10.0226 10.9873C9.45228 10.9873 8.98997 10.525 8.98997 9.95469C8.98997 9.3844 9.45228 8.9221 10.0226 8.9221C10.5928 8.9221 11.0551 9.3844 11.0551 9.95469Z",
    fill: "#FFC825"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3576 9.95469C15.3576 10.62 14.8183 11.1594 14.1529 11.1594C13.4876 11.1594 12.9482 10.62 12.9482 9.95469C12.9482 9.28936 13.4876 8.75 14.1529 8.75C14.8183 8.75 15.3576 9.28936 15.3576 9.95469ZM15.1855 9.95469C15.1855 10.525 14.7232 10.9873 14.1529 10.9873C13.5826 10.9873 13.1203 10.525 13.1203 9.95469C13.1203 9.3844 13.5826 8.9221 14.1529 8.9221C14.7232 8.9221 15.1855 9.3844 15.1855 9.95469Z",
    fill: "#FFC825"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressClaim);
export default __webpack_public_path__ + "static/media/ProgressClaim.13764175bf4a47490306a6dd68da16f9.svg";
export { ForwardRef as ReactComponent };